import React from "react";
import { Link } from "react-router-dom";
import { Button } from "material-ui";
import Card, { CardActions, CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import { pathRole, isAdmin, isCustomerAdmin } from "utils/formatter";
import BrowserCheck from "components/BrowserCheck";
import ErrorMessage from "components/ErrorMessage";
import CTextField from "uis/CTextField";

const styles = theme => ({
  card: {
    margin: `${window.innerHeight / 4}px auto`,
    width: 600,
    backgroundColor: "#fbfbfb"
  },
  title: {
    backgroundColor: isAdmin()
      ? theme.palette.primary.main
      : theme.palette.primary.light,
    color: "white",
    padding: "10px 8px 6px"
  },
  productName: {
    fontSize: "1.3rem",
    float: "left",
    marginLeft: 10,
    letterSpacing: ".3rem"
  },
  titleSub: {
    float: "right",
    marginTop: 6
  },
  cardContent: {
    padding: "30px 50px 20px"
  },
  cardActions: {
    display: "block",
    marginTop: 30,
    textAlign: "center"
  },
  passwordResetLink: {
    textDecoration: "none",
    color: theme.palette.link,
    padding: "5px 10px",
    float: "right",
    fontSize: ".9rem"
  },
  clear: {
    clear: "both"
  }
});

class Login extends React.Component {
  componentDidMount() {
    this.props.getAlive();
  }

  title() {
    switch (pathRole()) {
      case "admin":
        return "管理者ログイン";
      case "customer_admin":
        return "担当者ログイン";
      default:
        return console.error("no case");
    }
  }

  loginParams() {
    const { loginId, customerId, password } = this.props.login;
    return {
      loginId,
      customerId,
      password
    };
  }

  render() {
    const { props } = this;
    const { login, classes } = props;

    return (
      <Card className={classes.card}>
        <div className={classes.title}>
          <div className={classes.productName}>NiserES</div>
          <div className={classes.titleSub}>{this.title()}</div>
          <div className={classes.clear} />
        </div>
        <CardContent className={classes.cardContent}>
          <BrowserCheck nallow />
          <ErrorMessage messages={login.errors} />

          {isCustomerAdmin() && (
            <div>
              <CTextField
                id="customerId"
                label="顧客ID"
                value={login.customerId}
                onChange={e => props.changeForm("customerId", e.target.value)}
                fullWidth
                margin="dense"
              />
              <br />
            </div>
          )}

          <CTextField
            id="login-id"
            label={isAdmin() ? "管理者ID" : "担当者ID"}
            value={login.loginId}
            margin="dense"
            onChange={e => props.changeForm("loginId", e.target.value)}
            fullWidth
          />
          <br />

          <CTextField
            id="password"
            label="パスワード"
            type="password"
            value={login.password}
            onChange={e => props.changeForm("password", e.target.value)}
            margin="dense"
            fullWidth
          />
        </CardContent>

        <CardActions className={classes.cardActions}>
          <Button raised onClick={() => props.handleLogin(this.loginParams())}>
            ログイン
          </Button>
        </CardActions>

        <Link
          to={
            isCustomerAdmin()
              ? "/customer_admin/send_reset_password"
              : "send_reset_password"
          }
          className={classes.passwordResetLink}
        >
          パスワードを忘れた方はこちら
        </Link>

        <div className={classes.clear} />
      </Card>
    );
  }
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.jsx